<template>
 <div class="cont app-container">
    <div class="left">
      <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini">
        <div class="">
          <el-form-item label="控货方:" prop="oneCustomerTaxId">
            <el-select  v-model="searchFrom.oneCustomerTaxId"  placeholder="请选择">
              <el-option v-for="val in oneList" :label="val.oneCustomerName" :value="val.oneCustomerTaxId" :key="val.oneCustomerTaxId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在仓库:" prop="organizationId">
            <el-select v-model="searchFrom.organizationId"  placeholder="请选择" >
              <el-option v-for="val in cangkuList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-button type="primary" @click="getList">查询</el-button>
          <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" class="tableComent"
        @current-change="xuanFN" style="width: 100%" height="100%" center border highlight-current-row>
       <!-- <el-table-column type="index" prop="date"  width="55" label="序号"></el-table-column> -->
       <el-table-column prop="oneCustomerName"  min-width="200" :formatter="emptyFn" label="控货方"></el-table-column>
       <el-table-column prop="organizationName"  min-width="200" :formatter="emptyFn" label="所在仓库"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    </div>
    <!-- 右边 -->
    <div class="right">
      <div class="formBox" ref="searchBoxZL">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="inpBox">
            <template v-for="item in tableArr">
              <el-form-item :label="item.name+':'" prop="productionPlaceName"  :key="item.key" v-if="item.type!=1">
                <el-input  placeholder="" v-model="searchFromZL[item.key]"></el-input>
              </el-form-item>
               <el-form-item label="货物类型:" class="jiage" prop="goodTypeName" :key="item.key" v-if="item.type==1">
                <el-select  v-model="searchFromZL.goodTypeName"  value-key="productId" >
                  <el-option v-for="item in productTypes" :label="item.show_name" :value="item.show_name" :key="item.item_no"></el-option>
                </el-select>
              </el-form-item>
            </template>
             <!-- <el-form-item label="产地:" prop="productionPlaceName">
                <el-input  placeholder="" v-model="searchFromZL.productionPlaceName"></el-input>
              </el-form-item>
              <el-form-item label="货物类型:" class="jiage" prop="goodTypeName">
                <el-select  v-model="searchFromZL.goodTypeName"  value-key="productId" >
                  <el-option v-for="item in productTypes" :label="item.show_name" :value="item.show_name" :key="item.item_no"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="材质:" prop="materialName">
                <el-input  placeholder="" v-model="searchFromZL.materialName"></el-input>
              </el-form-item>
              <el-form-item label="规格:" prop="specificationName">
                <el-input  placeholder="" v-model="searchFromZL.specificationName"></el-input>
              </el-form-item> -->
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="getListZL" >查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetFormZL('searchFrom')">重置</el-button>
                </el-form-item>
                 <el-form-item >
                  <el-button type="primary"  @click="exportFn" :disabled="isDisable" >导出</el-button>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">累计货转量：<span class="red">{{tongji.totalControlWeight}}</span>吨</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">累计货转件：<span class="red">{{tongji.totalControlNumber}}</span>件</p>
                </el-form-item>
                <el-form-item v-if="zhongyuanFlag">
                  <p class="margin0">累计未分配量：<span class="red">{{notIssuedControlWeight}}</span>吨/<span class="red">{{notIssuedControlNumber}}</span>件</p>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:hZL}">
      <el-table :data="tableListZL"  ref="table1" v-loading="loadingZL"   bordersize="mini" style="width: 100%" height="100%"  center border >
       <el-table-column type="index" prop="date"  width="55" label="序号"></el-table-column>
         <template v-for="item in tableArr">
           <el-table-column  :property="item.key" min-width="150"  :key="item.key" :formatter="emptyFn"   :label="item.name"></el-table-column>
        </template>
        <!-- <el-table-column property="productionPlaceName" width="200"  label="产地"></el-table-column>
         <el-table-column property="goodTypeName"  width="100" label="货物类型"></el-table-column>
        <el-table-column property="specificationName" width="120"  label="规格"></el-table-column>
        <el-table-column property="materialName" width="120" :formatter="emptyFn" label="材质"></el-table-column> -->
        <el-table-column property="number" width="130" :formatter="emptyFn"  label="">
           <template slot="header" >
            <el-tooltip class="item" effect="dark" content="累计货转量=每一次下发控货量合计" placement="top-start">
              <div>累计货转量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
            <template scope="scope">
           <div>
              <el-button type="text" size="mini"   @click="mingxiFN(scope.row)">
                <span v-if="scope.row.controlWeight">{{scope.row.totalControlWeight}}吨</span>
                <span v-if="scope.row.controlWeight&&scope.row.controlPiece">/</span>
                <span v-if="scope.row.controlPiece">{{scope.row.totalControlNumber}}件</span>
              </el-button>
           </div>
          </template>
        </el-table-column>
        <el-table-column property="turnTotalActualWeight" width="130" :formatter="emptyFn"  label="">
           <template slot="header" >
            <el-tooltip class="item" effect="dark" content="实际出库量=累计出库量+累计客户盘盈盘亏量" placement="top-start">
              <div>实际出库量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
           <template scope="scope">
            <div> {{scope.row.outActualWeight}}吨/{{scope.row.billTotalActualNumber}}件</div>
          </template>
        </el-table-column>
        <el-table-column property="number" width="130" :formatter="emptyFn"  label="">
           <template slot="header">
            <el-tooltip class="item" effect="dark" content="货转出库量=累计转货数量（不含回购、不含钢厂转货）" placement="top-start">
              <div>货转出库量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
           <template scope="scope">
            <div> {{scope.row.turnTotalActualWeight}}吨/{{scope.row.turnTotalActualNumber}}件</div>
          </template>
        </el-table-column>
        <el-table-column property="number" width="130" :formatter="emptyFn"  label="">
           <template slot="header">
            <el-tooltip class="item" effect="dark" content="未提量=累计货转量-实际出库量-货转出库量" placement="top-start">
              <div>未提量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
           <div>
              <span v-if="scope.row.controlWeight">{{scope.row.controlStockWeight}}吨</span>
              <span v-if="scope.row.controlWeight&&scope.row.controlPiece">/</span>
              <span v-if="scope.row.controlPiece">{{scope.row.controlStockNumber}}件</span>
           </div>
          </template>
        </el-table-column>
        <el-table-column property="number" width="130" :formatter="emptyFn"  label="" v-if="zhongyuanFlag">
           <template slot="header" >
            <el-tooltip class="item" effect="dark" content="货权剩余量=累计货转量-进行中出库计划量-实际出库量-进行中转货量-实际转货量" placement="top-start">
              <div>货权剩余量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
           <div>
              <span v-if="scope.row.controlWeight">{{scope.row.surplusControlWeight}}吨</span>
              <span v-if="scope.row.controlWeight&&scope.row.controlPiece">/</span>
              <span v-if="scope.row.controlPiece">{{scope.row.surplusControlNumber}}件</span>
           </div>
          </template>
        </el-table-column>
        <el-table-column property="number" width="130" :formatter="emptyFn"  label="" v-if="!zhongyuanFlag">
           <template slot="header" >
            <el-tooltip class="item" effect="dark" content="货权剩余=累计货转量-进行中出库计划量-实际出库量-实际转货量" placement="top-start">
              <div>货权剩余量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
           <div>
              <span v-if="scope.row.controlWeight">{{scope.row.surplusControlWeight}}吨</span>
              <span v-if="scope.row.controlWeight&&scope.row.controlPiece">/</span>
              <span v-if="scope.row.controlPiece">{{scope.row.surplusControlNumber}}件</span>
           </div>
          </template>
        </el-table-column>
        <el-table-column property="number" width="120" :formatter="emptyFn"  label="">
           <template slot="header" >
            <el-tooltip class="item" effect="dark" content="库存量=实时库存量" placement="top-start">
              <div>库存量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
           <template scope="scope">
            <div> {{scope.row.totalAllWeight}}吨/{{scope.row.totalNumber}}件</div>
          </template>
        </el-table-column>
        <el-table-column property="number" min-width="120" :formatter="emptyFn"  label="">
           <template slot="header" >
            <el-tooltip class="item" effect="dark" content="未分配量=实时库存量+实际出库量+货转出库量-累计货转量" placement="top-start">
              <div>未分配量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
           <div>
              <span v-if="scope.row.controlWeight">{{scope.row.notIssuedControlWeight}}吨</span>
              <span v-if="scope.row.controlWeight&&scope.row.controlPiece">/</span>
              <span v-if="scope.row.controlPiece">{{scope.row.notIssuedControlNumber}}件</span>
           </div>
          </template>
        </el-table-column>
        <el-table-column property="number" min-width="120" :formatter="emptyFn"  label="" v-if="zhongyuanFlag">
           <template slot="header" >
            <el-tooltip class="item" effect="dark" content="待赎货量=货权剩余量-待处理提单-（装车中提单量-装车中提单出库计划量-装车中出库量）" placement="top-start">
              <div>待赎货量<i class="el-icon-info"></i></div>
            </el-tooltip>
          </template>
          <template scope="scope">
           <div>
             <span v-if="scope.row.controlWeight">
                <span class="red" v-if="scope.row.ransomedGoodsWeight<0">{{scope.row.ransomedGoodsWeight}}</span>
                <span v-else>{{scope.row.ransomedGoodsWeight}}</span>吨
              </span>
              <span v-if="scope.row.controlWeight&&scope.row.controlPiece">/</span>
              <span v-if="scope.row.controlPiece">
                <span class="red" v-if="scope.row.ransomedGoodsNumber<0">{{scope.row.ransomedGoodsNumber}}</span>
                <span v-else>{{scope.row.ransomedGoodsNumber}}</span>件
              </span>
           </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <!-- <div>
      <el-pagination background
        @size-change="handleSizeChangeZL"
        @current-change="handleCurrentChangeZL"
        :current-page="searchFromZL.pageNo"
        :page-size="searchFromZL.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalZL">
      </el-pagination>
    </div> -->
    </div>
    <!-- 控货明细 -->
    <el-dialog title="控货明细" :close-on-click-modal="false" :visible.sync="KHMXdialog" @close="closeDialog"  width="1200px" center>
      <div>
        <div style="border-bottom: 1px dashed #ddd; margin-bottom: 10px;">
          <p> <span v-if="row.controlWeight">累计货转量：<span class="red">{{row.totalControlWeight}}</span>吨</span> &nbsp;&nbsp;
          <span v-if="row.controlPiece">累计货转件数：<span class="red">{{row.totalControlNumber}}</span>件 </span></p>
        </div>
       <el-form :inline="true" v-model="MXsearchFrom"  class="demo-form-inline" label-width="90px" size="mini">
         <div class="searchBox inpBox">
            <el-form-item label="增减类型:" prop="billType">
              <el-select v-model="MXsearchFrom.virtualControlType" placeholder="请选择">
                <el-option  label="增项" value="1" ></el-option>
                <el-option  label="减项" value="2" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单号:" prop="businessNo">
                <el-input  placeholder="" v-model="MXsearchFrom.businessNo"></el-input>
              </el-form-item>
              <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="MXsearchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="getMXList">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="MXresetForm">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :disabled="isDisable"  @click="MXexportFn">导出</el-button>
              </el-form-item>
        </div>
      </el-form>
       <el-table :data="KHMXList"  ref="table" v-loading="loading1"   bordersize="mini"
         style="width: 100%" height="300px"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="virtualControlNo"  min-width="200" :formatter="emptyFn" label="控货编号"></el-table-column>
        <el-table-column property="virtualControlType" label="增减类型" >
          <template scope="scope">
            <div>
           {{[ "增项", "减项",][scope.row.virtualControlType-1]}}
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="virtualControlNumber"   :formatter="emptyFn"  label="件数"></el-table-column>
         <el-table-column prop="virtualControlWeight"     label="重量(吨)"></el-table-column>
          <el-table-column prop="businessNo"   :formatter="emptyFn" label="单号"></el-table-column>
          <el-table-column prop="supplementNo"   :formatter="emptyFn" label="补充单号"></el-table-column>
          <el-table-column prop="createUserName" width="150aa"   :formatter="emptyFn" label="创建人"></el-table-column>
         <el-table-column width="170" property="createTime" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
          <el-table-column prop="tenantName" width="200"  :formatter="emptyFn" label="创建组织"></el-table-column>
          <el-table-column property="dataSource" label="数据来源" >
          <template scope="scope">
            <div>
           {{["货主端","仓储端"][scope.row.dataSource-1]}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div>
      <el-pagination background
        @size-change="MXhandleSizeChange"
        @current-change="MXhandleCurrentChange"
        :current-page="MXsearchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="MXsearchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="MXtotla">
      </el-pagination>
    </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="KHMXdialog = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn, getAttributeA } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import { getDictionaryAll, getOneCustomerDropDownForHZ, getOrganizationNameList, getMasterListForHZ } from '@/api/soc-stock-cosco'
import { controlSum, SVCRlist, controlList, controlListZy } from '@/api/common-signature'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      tableArr: [],
      h: 500,
      hZL: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      tableListZL: [],
      searchFromZL: {
        pageNo: 1,
        pageSize: 500
      },
      loadingZL: false,
      loading: false,
      totalZL: 0,
      tongji: {},
      oneList: [],
      cangkuList: [],
      productTypes: [],
      isDisable: false,
      TwoIsDisable: false,
      currentRow: {},
      KHdialog: false,
      addFrom: {},
      MXsearchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      loading1: false,
      KHMXdialog: false,
      KHMXList: [],
      MXtotla: 0,
      rules: {
        virtualControlType: [
          { required: true, message: '请选择增减类型', trigger: 'blur' }
        ],
        virtualControlWeight: [
          { required: true, message: '请输入控货重量', trigger: 'blur' },
          this.rule.weight
        ],
        virtualControlNumber: [
          { required: true, message: '请输入控货件数', trigger: 'blur' }
        ],
        supplementNo: [
          { required: true, message: '请输入补充单号', trigger: 'blur' }
        ],
        businessNo: [
          { required: true, message: '请输入单号', trigger: 'blur' }
        ]
      },
      row: {},
      zhongyuanFlag: false, // 是否是中远逻辑
      notIssuedControlWeight: 0,
      notIssuedControlNumber: 0,
      btnFlg: [],
      btnIdArr: ['00FP009B001', '00FP009B002', '00FP009B003', '00FP009B004', '00FP009B005', '00FP009B006']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/controlInstruct')
    getDictionaryAll({ groupNo: 'thread_product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '全部', item_no: '' })
    })
    getOneCustomerDropDownForHZ().then(res => {
      this.oneList = res
      this.oneList.unshift({ oneCustomerName: '全部', oneCustomerTaxId: '' })
    })
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.cangkuList = [{ relTenantName: localStorage.getItem('createTenantName'), relTenantCode: localStorage.getItem('createTenantCode') }]
      this.$set(this.searchFrom, 'organizationId', this.cangkuList[0].relTenantCode)
      getAttributeA('ARRsurplusControl', this.cangkuList[0].relTenantCode).then(res => {
        this.zhongyuanFlag = res[0] === '0'
        this.getList(this.searchFrom)
      })
    }
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        if (_this.KHdialog == true) {
          _this.saveFn()
        } else {
        // _this.getList(_this.searchFrom)
          _this.getListZL()
        }
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let hZL = this.$refs.searchBoxZL.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 165) + 'px'
    this.hZL = (pH - hZL - 158) + 'px'
  },
  methods: {
    // 下发明细量
    mingxiFN (row) {
      this.KHMXdialog = true
      this.row = row
      if (row.controlId) {
        this.MXsearchFrom = {
          pageNo: 1,
          pageSize: 50,
          controlId: row.controlId
        }
        this.getMXList()
      } else {
        this.KHMXList = []
        this.MXtotla = 0
      }
    },
    // 选择一二级客户
    xuanFN (val) {
      if (val) {
        this.currentRow = val
        this.tableArr = []
        this.searchFromZL = {
          pageNo: 1,
          pageSize: 500
        }
        this.getListZL()
        if (val.generalControl == 1) {
          this.tableArr = [
            { name: '产地', key: 'productionPlaceName' },
            { name: '货物类型', key: 'goodTypeName', type: 1 },
            { name: '材质', key: 'materialName' },
            { name: '规格', key: 'specificationName' }
          ]
        } else {
          if (val.productionPlace) {
            this.tableArr.push({ name: '产地', key: 'productionPlaceName' })
          }
          if (val.goodType) {
            this.tableArr.push({ name: '货物类型', key: 'goodTypeName', type: 1 })
          }
          if (val.material) {
            this.tableArr.push({ name: '材质', key: 'materialName' })
          }
          if (val.specification) {
            this.tableArr.push({ name: '规格', key: 'specificationName' })
          }
        }
      }
    },
    // 导出
    exportFn () {
      let form = this.searchFromZL
      exportExcel(
        this.global.signature + '/sVirtualControl/exportControlListExcelZy',
        form,
        '控货指令'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    MXexportFn () {
      let form = this.MXsearchFrom
      this.MXsearchFrom.controlWeight = this.row.controlWeight
      this.MXsearchFrom.controlPiece = this.row.controlPiece
      this.MXsearchFrom.productionPlaceName = this.row.productionPlaceName
      this.MXsearchFrom.goodTypeName = this.row.goodTypeName
      this.MXsearchFrom.materialName = this.row.materialName
      this.MXsearchFrom.specificationName = this.row.specificationName
      exportExcel(
        this.global.signature + '/sVirtualControlRecord/exportControlRecordExcel',
        form,
        '控货明细'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    exportCustomer () {
      let form = this.searchFrom
      exportExcel(
        this.global.signature + '/sVirtualControl/exportAllControlList',
        form,
        '控货指令列表'
      )
      this.TwoIsDisable = true
      setTimeout(() => {
        this.TwoIsDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 获取指令列表
    getListZL () {
      this.loadingZL = true
      // this.searchFromZL.oneCustomerTaxId = this.currentRow.oneCustomerTaxId
      // this.searchFromZL.twoCustomerTaxId = this.currentRow.twoCustomerTaxId
      // this.searchFromZL.organizationId = this.currentRow.organizationId
      this.searchFromZL.masterId = this.currentRow.id
      if (this.zhongyuanFlag) {
        controlListZy(this.searchFromZL).then(res => {
          this.loadingZL = false
          this.tableListZL = []
          res.pageInfo.list.forEach(item => { // 判断累计货转量其中一个有值就显示
            if (item.totalControlWeight || item.totalControlNumber || item.totalAllWeight || item.totalNumber ||
          item.turnTotalActualWeight || item.turnTotalActualNumber || item.outActualWeight || item.billTotalActualNumber) {
              this.tableListZL.push(item)
            }
          })
          // this.tableListZL = res.pageInfo.list
          // this.totalZL = res.pageInfo.total
          this.notIssuedControlWeight = res.notIssuedControlWeight
          this.notIssuedControlNumber = res.notIssuedControlNumber
        })
      } else {
        controlList(this.searchFromZL).then(res => {
          this.loadingZL = false
          this.tableListZL = res.list
          this.totalZL = res.total
        })
      }

      controlSum(this.searchFromZL).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChangeZL (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChangeZL (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },

    // 获取客户列表
    getList () {
      this.loading = true
      getMasterListForHZ(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        if (res.list.length > 0) {
          this.$refs.table.setCurrentRow(res.list[0])
          this.xuanFN(res.list[0])
        } else {
          this.tableListZL = []
          this.tongji = {}
        }
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 获取列表
    getMXList () {
      this.loading1 = true
      SVCRlist(this.MXsearchFrom).then(res => {
        this.loading1 = false
        this.KHMXList = res.list
        this.MXtotla = res.total
      })
    },
    // 每页条数
    MXhandleSizeChange (val) {
      this.MXsearchFrom.pageSize = val
      this.getMXList()
    },
    // 当前页
    MXhandleCurrentChange (val) {
      this.MXsearchFrom.pageNo = val
      this.getMXList()
    },
    MXresetForm () {
      this.MXsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        controlId: this.row.controlId
      }
      this.getMXList()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        organizationId: this.cangkuList[0].relTenantCode
      }
      this.getList(this.searchFrom)
    },
    resetFormZL (formName) {
      this.searchFromZL = {
        pageNo: 1,
        pageSize: 500
      }
      this.getListZL()
    },
    closeDialog () {
      this.addFrom = {}
      this.BDFrom = {}
    }
  }

}
</script>

<style scoped lang='less'>
.cont{
  // height: 100%;
  height: calc(100vh - 42px - 35px - 42px);
  width: 100%;
  display: flex;
  box-sizing: border-box;
  .right{
    width: 75%;
    // height: calc(100% + 12px);
    // margin-top: -12px;
    // padding-top:12px;
    border-left:5px solid #ddd ;
    box-sizing: border-box;
    position: relative;
    // padding-bottom:50px;
  }
  .left{
    width: 25%;
    height: 100%;
    box-sizing: border-box;
  }
  .zhedieBox{
    width:60px;
    border-left:10px solid #ddd ;
    margin-top: -12px;
    padding-top:12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #8cb3e6;
    cursor: default;
    span{
      writing-mode:tb-rl;
      letter-spacing:0.3em;
      color: #fff;
    }
    i{
      margin-top: 15px;
      color: #fff;
    }
   /deep/.el-badge__content{
      border: none;
      top:-8px;
    }
  }
}
 .inpBox .el-date-editor{
      width: 350px!important;
  }
</style>
